import axios from 'axios'
import vSelect from 'vue-select'
import { mapGetters, mapMutations } from 'vuex'
import { MaximizeIcon } from 'vue-feather-icons'

import ModalMixin from '@/mixins/ModalMixin.js'
import CreateOption from '@/mixins/CreateOption.js'
import TransformOptions from '@/mixins/TransformOptions.js'
import OpenBoxMixin from '@/mixins/OpenBoxMixin.js'
import LogoMain from '@/vcs/_shared/LogoMain.vue'
import AvailableBoxesModal from '@/vcs/_shared/modals/AvailableBoxesModal.vue'
import ChooseBoxModal from '@/vcs/_shared/modals/ChooseBoxModal.vue'
import PhonePrefixSelect from '@/vcs/_shared/PhonePrefixSelect.vue'
import UserSearchSelect from './user-search-select.vue'
import UserAndPhoneSearchSelect from './user-and-phone-search-select.vue'
import { eventBus } from '@/vcs/_shared/eventBus'
import PhysicalQrReaderModal from '@/vcs/_shared/modals/PhysicalQrReaderModal.vue'
import QrModal from '@/vcs/_shared/modals/QrModal.vue'

export default {
  name: 'DeliveryStart',
  components: {
    LogoMain,
    vSelect,
    PhonePrefixSelect,
    MaximizeIcon,
    UserSearchSelect,
    UserAndPhoneSearchSelect
  },
  mixins: [ModalMixin, CreateOption, TransformOptions, OpenBoxMixin],
  data: function () {
    return {
      user: null,
      userOrPhone: null, // model for second v-select

      users: [],
      userSearch: '',
      phoneNumber: '',
      phonePrefix: '48',
      AvailableBoxesModal,

      deliveryByUser: {
        phone: '',
        phonePrefix: '48',
        deliveryKey: ''
      }
    }
  },
  computed: {
    ...mapGetters({
      cp: 'getCurrentCp',
      deviceId: 'getDeviceId',
      userToken: 'getUserToken'
    }),
    isByUserScenario() {
      return this.cp.deliveryScenarios.includes('by_user')
    },
    isByDelivererScenario() {
      return this.cp.deliveryScenarios.includes('by_deliverer')
    }
  },
  mounted() {
    this.$store.commit('startSessionTimer')
    document.addEventListener('click', this.$clickListener)
    this.changeVSelectTypeToNumber()
    eventBus.$emit('refresh-token-via-websockets')
    eventBus.$on('pass-qr-reader-event-to-delivery', this.processQrDataAndDeliver)
  },
  beforeDestroy() {
    eventBus.$off('pass-qr-reader-event-to-delivery', this.processQrDataAndDeliver)
  },
  methods: {
    focusPhone() {
      this.$slideUp()
      this.emitEvent()
    },
    focusDeliveryKey() {
      this.$slideUp()
      this.emitEvent()
    },
    emitEvent() {
      eventBus.$emit('refresh-token-via-websockets')
    },
    openQrReader() {
      this.cp.isPhysicalScanerEnabled
        ? this.openPhysicalQrReaderModal()
        : this.openQrModal()
    },
    openQrModal() {
      this.$store.commit('modal/open', {
        cmp: QrModal,
        size: 'full',
        disableRedirect: true
        // callback: this.processQrData, # very very fucked up
      })
    },
    openPhysicalQrReaderModal() {
      this.$store.commit('modal/open', {
        cmp: PhysicalQrReaderModal,
        size: 'popup slightly-higher',
        callback: this.processQrDataAndDeliver,
        disableRedirect: true
      })
    },
    processQrDataAndDeliver(data) {
      if (this.$isFrontex) {
        this.processQrData(data)
        this.deliver({ skipPackageDetails: true })
      } else {
        this.processQrData(data)
        this.deliver()
      }
    },
    processQrData(data) {
      // INFO: data = '{"phone": null, "phone_prefix": null, "collection_key": "123456", "user_email": "test@test.pl"}'
      let dataParsed
      try {
        dataParsed = JSON.parse(data)
      } catch (error) {
        this.$errorHumanized(null, `QR does not contain valid data: ${data}`)
        return
      }

      if (dataParsed.phone_prefix) {
        // INFO: Only update when is not null, because there is no visual change in prefix, I need to add this
        this.phonePrefix = dataParsed.phone_prefix
      }
      this.deliveryByUser.phone = dataParsed.phone || ''
      this.deliveryByUser.deliveryKey = dataParsed.delivery_key || ''
      // INFO: EMAIL is in QR, but we are not sending it
      // why tho ?
    },
    onPrefixSelectedForUserScenario(prefix) {
      this.deliveryByUser.phonePrefix = prefix.substr(1) // removing `+` sign
    },
    deliver(options = { skipPackageDetails: false }) {
      const goToDeliveryRequestUpdate =
        !options.skipPackageDetails && this.cp.packageDetailsEnabled
      if (
        !(
          this.deliveryByUser.deliveryKey &&
          this.deliveryByUser.phone &&
          this.deliveryByUser.phonePrefix
        )
      ) {
        this.$errorHumanized(null, this.$t('error.fillPackageInfo'))
        return
      }

      this.$blockUI()
      axios({
        method: 'post',
        url: '/auth/delivery_requests/sign_in',
        params: {
          phone: this.deliveryByUser.phone,
          phone_prefix: this.deliveryByUser.phonePrefix,
          delivery_key: this.deliveryByUser.deliveryKey,
          device_id: this.$deviceId()
        }
      })
        .then((response) => {
          let token = response.data.token
          let drId = response.data.deliveryRequest.id

          window.localStorage.setItem('delivery_request_token', token)
          this.setDeliveryRequestId(drId)

          if (goToDeliveryRequestUpdate) {
            this.goToDeliveryRequestUpdate(drId)
          } else {
            if (this.cp.pickableSizeEnabled) {
              this.openSelectBoxSizeModal(drId)
            } else {
              this.openBoxMixinFn(drId, token)
            }
          }
        })
        .catch((error) => {
          if (Object.keys(error.response.data.errors) == 'phone') {
            this.$errorHumanized(error)
          } else if (Object.keys(error.response.data.errors) == '10') {
            this.openNoAvailableBoxesModal()
          } else {
            this.$errorHumanized(error)
          }
        })
        .finally(() => {
          this.$unblockUI()
        })
    },
    ...mapMutations(['setDeliveryRequestId']),
    // fetchUsers(search, loading) {
    //   eventBus.$emit('refresh-token-via-websockets')
    //   if (search.length >= 3) {
    //     loading(true)
    //     axios({
    //       method: 'get',
    //       url: `collection_points/${this.deviceId}/users`,
    //       params: {
    //         'q[query]': search
    //       }
    //     })
    //       .then((response) => {
    //         let threeFirstUsers = response.data.slice(0, 3)
    //         this.users = this.transformOptions(threeFirstUsers)
    //       })
    //       .catch((error) => {
    //         this.$errorHumanized(error)
    //       })
    //       .finally(() => {
    //         loading(false)
    //       })
    //   } else if (search.length == 0) {
    //     this.users = []
    //   }
    // },
    findUser(event) {
      eventBus.$emit('refresh-token-via-websockets')
      // INFO: DO_GAPS-6
      const doesNotHaveWhitespace = !/\s/g.test(this.userSearch)

      if (this.userSearch.length <= 3) {
        this.user = null
      } else if (
        this.userSearch.length > 3 &&
        event.inputType == 'insertText' &&
        doesNotHaveWhitespace
      ) {
        axios({
          method: 'get',
          url: `collection_points/${this.deviceId}/user`,
          params: {
            'q[query]': this.userSearch
          }
        })
          .then((response) => {
            if (response.data) {
              this.user = response.data
              this.userSearch = response.data.email
            } else {
              this.user = null
            }
          })
          .catch((error) => {
            this.$errorHumanized(error)
          })
      }
    },
    createDR() {
      this.$blockUI()
      let params
      if (this.user) {
        params = {
          'delivery_request[kind]': 'outbound',
          'delivery_request[user_id]': this.user.id,
          app_kind: 'tablet'
        }
      } else if (this.isUser(this.userOrPhone)) {
        params = {
          'delivery_request[kind]': 'outbound',
          'delivery_request[user_id]': this.userOrPhone.id,
          app_kind: 'tablet'
        }
      } else if (this.phoneNumber && !this.user) {
        params = {
          'delivery_request[kind]': 'outbound',
          'delivery_request[phone]': this.phoneNumber,
          'delivery_request[phone_prefix]': this.phonePrefix,
          app_kind: 'tablet'
        }
      }
      let dataContext = ''
      let errorContext = ''
      axios({
        method: 'post',
        url: `collection_points/${this.deviceId}/delivery_requests`,
        params: params
      })
        .then((response) => {
          let token = response.data.token
          let drId = response.data.deliveryRequest.id

          window.localStorage.setItem('delivery_request_token', token)
          this.setDeliveryRequestId(drId)

          if (this.cp.packageDetailsEnabled) {
            dataContext = 'goToDeliveryRequestUpdate'
            this.goToDeliveryRequestUpdate(drId)
          } else {
            if (this.cp.pickableSizeEnabled) {
              dataContext = 'openSelectBoxSizeModal'
              this.openSelectBoxSizeModal(drId)
            } else {
              dataContext = 'openBoxMixinFn'
              this.openBoxMixinFn(drId, token)
            }
          }

          return response.data
        })
        .catch((error) => {
          if (error) {
            if (error.response && error.response.data && error.response.data.errors) {
              if (Object.keys(error.response.data.errors) == 'phone') {
                this.$errorHumanized(error)
              } else if (Object.keys(error.response.data.errors) == '10') {
                this.openNoAvailableBoxesModal()
              }
            } else {
              this.$errorHumanized(error)
            }

            // if (this.deviceId == 'acc02' || this.deviceId == 'acc01') {
            //   this.$airbrake.notify({
            //     error: new Error(
            //       `createDR ${new Date()} - ${dataContext} ::: ${
            //         this.deviceId
            //       }`
            //     ),
            //     context: { component: 'PWA TABLET' },
            //     params: {
            //       response: data,
            //       params
            //     }
            //   })
            // }
          }
        })
        .finally(this.$unblockUI)
    },

    openSelectBoxSizeModal(drId) {
      this.$store.commit('modal/open', {
        cmp: ChooseBoxModal,
        size: 'full',
        callback: () => {
          this.redirectToConfirmation(drId)
        }
      })
    },
    redirectToConfirmation(id) {
      this.$router.push(`/delivery/delivery-request/${id}/confirmation`)
    },
    goToDeliveryRequestUpdate(id) {
      this.$router.push(`/delivery/delivery-request/${id}`)
    },
    onPrefixSelected(prefix) {
      this.phonePrefix = prefix.substr(1) // INFO: removing `+` sign
    },
    displayUserSearch() {
      return this.cp.allowUserSearch && !this.cp.allowAnonymousUser
    },
    displayPhoneInput() {
      return !this.cp.allowUserSearch && this.cp.allowAnonymousUser
    },
    displayBothInputs() {
      return this.cp.allowUserSearch && this.cp.allowAnonymousUser
    },
    userOrPhoneSelected(data) {
      // INFO: We update phoneNumber only during option creation
      if (this.isCreatedOption(data)) {
        let phoneNumber = data.itemData
        this.phoneNumber = phoneNumber
      } else {
        this.phoneNumber = ''
      }
    },
    isUser(user) {
      return (user || {}).id
    },
    isCreatedOption(user) {
      return (user || {}).itemData && !(user || {}).id
    },
    changeVSelectTypeToNumber() {
      // INFO: We change type of input on the fly, see `PhonePrefixSelect` for another example.
      if (
        this.$refs.phoneNumberVSelect?.$el?.children?.[0].children?.[0].children?.[0]
          ?.type
      )
        this.$refs.phoneNumberVSelect.$el.children[0].children[0].children[0].type =
          'number'
    },
    userSelectFocused() {
      this.userOrPhone = null
      this.phoneNumber = ''
      this.$slideUp()
    },
    userOrPhoneSelectFocused() {
      this.user = null
      this.phoneNumber = ''
      this.userOrPhone = null
      this.$slideUp()
    },
    openAvailableBoxesModal() {
      this.$store.commit('modal/open', {
        cmp: AvailableBoxesModal,
        disableRedirect: true,
        size: 'full'
      })
    },
    updateUser(payload) {
      this.user = payload
    },
    updateUserOrPhone(payload) {
      this.userOrPhone = payload
    }
  }
}
